export const PlanningDetailsViews = {
    orders: "orders",
    ignored_orders: "ignored_orders",
    stock_requirements: "stock_requirements",
    insights: "insights",
} as const;

export type PlanningDetailsViewsType = keyof typeof PlanningDetailsViews;
